import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findCouponList= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v1/coupon?`+params,
        method: 'GET'
    })
}
export const addCoupon = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/coupon`,
        method: 'POST',
        data: data
    })
}
export const editCoupon = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/coupon`,
        method: 'PUT',
        data: data
    })
}
export const delCoupon = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-work/v1/coupon/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}
export const findCoupon= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v1/coupon/list?`+params,
        method: 'GET'
    })
}